import { useQuery } from 'react-query'

import { getArticle } from '../../endpoints/howTo'

export const useGetArticle = (id: string | undefined) => {
    return useQuery(['zendesk-article', id], async () => await getArticle(id), {
        enabled: !!id,
        refetchOnWindowFocus: false
    })
}
